import React from 'react';

import PanelRedesSociales from '../Utilitarios/PanelRedesSociales/index';
import NavBar from '../Utilitarios/NavBar/index';
import PanelLaUnidadEquipoDirector from '../Utilitarios/PanelLaUnidadEquipoDirector/index';
import PanelLaUnidadEquipo from '../Utilitarios/PanelLaUnidadEquipo/index';
import Footer from '../Utilitarios/Footer/index';

import './css/styles.css';

class LaUnidadEquipo extends React.Component{

    constructor(props){
        super(props);
        this.scrollUp = this.scrollUp.bind(this);
    }

    componentWillMount(){
        window.scrollTo(0, 0);
    }

    scrollUp(){
        window.scrollTo(0, 0);
    }

    render(){
        return(
            <div className="container_la_unidad_equipo">
                <PanelRedesSociales />
                <NavBar />
                <PanelLaUnidadEquipoDirector />
                <PanelLaUnidadEquipo />
                <Footer />
                <a class="btn-floating btn-large waves-effect waves-light pink button_top_all"
                   onClick={this.scrollUp}>
                    <i class="material-icons">expand_less</i>
                </a>
            </div>
        );
    }
}

export default LaUnidadEquipo;